import React from 'react';
import { Field, Input as FluentInput } from '@fluentui/react-components';

// Maps the legacy Input prop API onto Fluent's Field + Input so existing call
// sites (label, error, type, ...rest) keep working.
export default function Input({
  label,
  type = 'text',
  error,
  className = '',
  ...props
}) {
  return (
    <Field
      label={label}
      validationState={error ? 'error' : undefined}
      validationMessage={error || undefined}
    >
      <FluentInput type={type} className={className} {...props} />
    </Field>
  );
}
